//on document loaded

// Import JS

document.addEventListener("DOMContentLoaded", function() {
  //initialize swiper
  if (document.querySelector(".swiperHero")) {
    var swiper = new Swiper(".swiperHero", {
      effect: "fade", // Ajoute l'effet de fade
      fadeEffect: {
        crossFade: true, // Active le cross-fade entre les slides
      },
      speed: 1000, // Durée de la transition en millisecondes
      autoplay: {
        delay: 3000, // Délai de 5 secondes entre chaque slide
        disableOnInteraction: false, // Continue l'autoplay après interaction
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });

    const nextButton = document.querySelector(".swiper-button-next");
    const prevButton = document.querySelector(".swiper-button-prev");

    /* 
    nextButton.addEventListener("click", function() {
      swiper.slideNext();
    });
    prevButton.addEventListener("click", function() {
      swiper.slidePrev();
    });
*/
  }
});
